import $ from "jquery";

const hideContextMenu = () => {
    let contextMenu = $("#contextMenu");
    contextMenu.css({
        display: "none"
    });
};

export { hideContextMenu };
